import React from "react";

const REASON_LABELS = {
  hire: "Hire VBB",
  pitch: "Pitch a project",
  partner: "Partner / collab",
  hi: "Just say hi",
};

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export default function ContactListItem({
  contact,
  active,
  selected,
  onSelect,
  onToggleSelect,
}) {
  const unread = !contact.is_read;
  const rowClasses = `flex items-stretch w-full text-left vbb-border-b transition-colors ${
    active
      ? "bg-[#0a0a0a] text-[#fafafa]"
      : `bg-transparent text-[#0a0a0a] hover:bg-[#f4f4f5] ${
          unread ? "border-l-[3px] border-l-[#e34234]" : ""
        }`
  }`;

  return (
    <div className={rowClasses}>
      <label
        className={`flex items-center px-3 cursor-pointer ${
          active ? "" : "hover:bg-[#eaeaea]"
        }`}
        onClick={(e) => e.stopPropagation()}
        data-testid={`admin-inbox-checkbox-label-${contact.id}`}
      >
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onToggleSelect(contact.id)}
          className="w-4 h-4 accent-[#e34234] cursor-pointer"
          aria-label={`Select submission from ${contact.name || "unknown"}`}
          data-testid={`admin-inbox-checkbox-${contact.id}`}
        />
      </label>
      <button
        onClick={() => onSelect(contact)}
        className="flex-1 min-w-0 p-5 text-left"
        data-testid={`admin-inbox-item-${contact.id}`}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            {unread && !active && (
              <span
                className="w-2 h-2 bg-[#e34234] flex-shrink-0"
                aria-label="Unread"
                data-testid={`admin-inbox-unread-dot-${contact.id}`}
              />
            )}
            <span
              className={`font-display uppercase text-base tracking-tight truncate ${
                unread && !active ? "font-black" : ""
              }`}
            >
              {contact.name || "—"}
            </span>
          </div>
          <div
            className={`font-mono-tiny ${
              active ? "text-[#cfcfcf]" : "text-[#6b6b6b]"
            } flex-shrink-0`}
          >
            {formatDate(contact.created_at)}
          </div>
        </div>
        <div
          className={`mt-1 text-[13px] truncate flex items-center gap-2 ${
            active ? "text-[#cfcfcf]" : "text-[#3a3a3a]"
          }`}
        >
          <span>{contact.email}</span>
          {contact.reason && REASON_LABELS[contact.reason] && (
            <span
              className={`font-mono-tiny px-1.5 py-0.5 border ${
                active ? "border-[#cfcfcf]" : "border-[#0a0a0a] text-[#0a0a0a]"
              }`}
            >
              {REASON_LABELS[contact.reason]}
            </span>
          )}
          {contact.company ? <span>· {contact.company}</span> : null}
        </div>
        <div
          className={`mt-2 text-[13px] line-clamp-2 ${
            active ? "text-[#fafafa]" : "text-[#2a2a2a]"
          }`}
        >
          {contact.message}
        </div>
      </button>
    </div>
  );
}
